import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowsCrossOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m1 12 4.086-4.086 1.272 1.273L4.446 11.1H11.1V4.446L9.187 6.359 7.914 5.086 12 1l4.086 4.086-1.273 1.272L12.9 4.446V11.1h6.654l-1.913-1.913 1.273-1.273L23 12l-4.086 4.086-1.273-1.273 1.913-1.913H12.9v6.654l1.913-1.912 1.273 1.272L12 23l-4.086-4.086 1.273-1.273 1.913 1.913V12.9H4.446l1.912 1.913-1.272 1.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowsCrossOutlinedSize24Glyph.displayName = 'ArrowsCrossOutlinedSize24Glyph';
